import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './planCarousel.module.scss';
import { useSwipeable } from 'react-swipeable';
import HtmlDecode from 'utils/htmlDecode';
import { useSelector } from 'react-redux';

const PlanCarousel = ({ children, className, title, isHome, ...res }) => {
  const ref = React.createRef();
  const [widths, setWidths] = React.useState([]);
  const [offset, setOffset] = React.useState(0);
  const [index, setIndex] = React.useState(0);
  const [rightMost, setRightMost] = React.useState(false);

  const asset = useSelector(state => state.asset);
  const { search_overCarousel_home_icon_surf } = asset;

  const onRightClicked = () => {
    const outerWidth = ref.current.parentNode.offsetWidth;
    const childrenStyles = window.getComputedStyle(ref.current, null);
    const paddingLeft = parseInt(
      childrenStyles.getPropertyValue('padding-left'),
    );
    const paddingRight = parseInt(
      childrenStyles.getPropertyValue('padding-right'),
    );
    const innerWidth =
      widths.length > 0 &&
      widths.reduce((a, b) => a + b) + paddingLeft + paddingRight;
    if (innerWidth - offset - outerWidth - widths[index] > 0) {
      // If there is enought room for the next card to slide
      setOffset(offset + widths[index]);
      setIndex(index + 1);
    } else if (innerWidth - offset - outerWidth > 0) {
      // Otherwise move only enought to leave the last card at the edge
      setOffset(offset + innerWidth - offset - outerWidth + paddingRight);
      setIndex(index + 1);
      setRightMost(true);
    }
  };

  const onLeftClicked = () => {
    const outerWidth = ref.current.parentNode.offsetWidth;
    const innerWidth = widths.length > 0 && widths.reduce((a, b) => a + b);
    if (innerWidth > outerWidth) {
      setRightMost(false);
    }
    if (index > 0) {
      let correctOffset = 0;
      for (let i = 0; i < index - 1; ++i) {
        correctOffset += widths[i];
      }
      setIndex(index - 1);
      setOffset(correctOffset);
      setRightMost();
    }
  };

  React.useEffect(
    () => {
      const list = Array.from(ref.current.children);
      setWidths(
        list.map(element => {
          const style =
            element.currentStyle || window.getComputedStyle(element);
          const width = element.offsetWidth;
          const margin =
            parseFloat(style.marginLeft) + parseFloat(style.marginRight);
          const border =
            parseFloat(style.borderLeftWidth) +
            parseFloat(style.borderRightWidth);
          return width + margin + border;
        }),
      );
      // Getting the children from async call produces a ref.current with no children
      // when first assigned, that's the reason we need to check for changes in children too
    },
    [ref.current, children],
  );

  const handlers = useSwipeable({
    // When we swipe to the left we want to advance to the right,
    // that's why it seems backwards
    onSwipedLeft: onRightClicked,
    onSwipedRight: onLeftClicked,
  });

  return (
    <div
      className={classNames(
        isHome ? styles.container : styles.containerV2,
        className,
      )}
      {...res}
    >
      <div
        className={
          isHome ? styles.navigationButtons : styles.navigationButtonsV2
        }
      >
        <div className="plan-selector__carousel__header">
          <h2 className="plan-selector__carousel__header__title">
            {HtmlDecode(title)}
          </h2>
        </div>
        <div className={styles.containesBtns}>
          <button
            className={classNames(styles.left, { [styles.active]: index > 0 })}
            onClick={onLeftClicked}
            disabled={index <= 0}
          >
            <img
              alt="prev button"
              className={`contents-carousel__header__navigation__prev-btn prev-plan-select`}
              src={search_overCarousel_home_icon_surf}
            />
          </button>
          <button
            className={classNames(styles.right, {
              [styles.active]: !rightMost,
            })}
            onClick={onRightClicked}
          >
            <img
              className={`contents-carousel__header__navigation__next-btn ${styles?.arrowRotate} ${
                !isHome ? styles.nextPlanSelect : ''
              }`}
              alt="next button"
              src={search_overCarousel_home_icon_surf}
            />
          </button>
        </div>
      </div>
      <div className={styles.carousel} {...handlers}>
        <div
          className={styles.children}
          ref={ref}
          style={{ transform: `translate(-${offset}px, 0)` }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

PlanCarousel.propTypes = {
  image: PropTypes.string,
  classes: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

PlanCarousel.defaultProps = {
  imageAlt: 'panel',
  classes: [],
};

export default PlanCarousel;
